export default [
  {
    path: 'gain-and-loss',
    name: 'admin:reports:gain-and-loss',
    component: () => import(/* webpackChunkName: "reports" */ '@/views/admin/management/reports/GainAndLoss.vue'),
  },
  {
    path: 'sales-per-category',
    name: 'admin:reports:sales-per-category',
    component: () => import(/* webpackChunkName: "reports" */ '@/views/admin/management/reports/SalesReport.vue'),
  },
  {
    path: 'sales-per-item',
    name: 'admin:reports:sales-per-item',
    component: () => import(/* webpackChunkName: "reports" */ '@/views/admin/management/reports/SalesReport.vue'),
  },
  {
    path: 'sales-per-delivery-area',
    name: 'admin:reports:sales-per-delivery-area',
    component: () => import(/* webpackChunkName: "reports" */ '@/views/admin/management/reports/SalesReport.vue'),
  },
  {
    path: 'sales-per',
    name: 'admin:reports:sales-per',
    component: () => import(/* webpackChunkName: "reports" */ '@/views/admin/management/reports/SalesReport.vue'),
  },
  {
    path: 'order-lines',
    name: 'admin:reports:order-lines',
    component: () => import(/* webpackChunkName: "reports" */ '@/views/admin/management/reports/OrderLinesReport.vue'),
  },
  {
    path: 'order-details',
    name: 'admin:reports:order-details',
    component: () => import(/* webpackChunkName: "reports" */ '@/views/admin/management/reports/OrderDetails.vue'),
  },
  {
    path: 'transferable-orders',
    name: 'admin:reports:transferable-orders',
    component: () => import(/* webpackChunkName: "reports" */ '@/views/admin/management/reports/TransferableOrdersReport.vue'),
  },
  {
    path: 'custom-report',
    name: 'admin:reports:custom-report',
    component: () => import(/* webpackChunkName: "reports" */ '@/views/admin/management/reports/CustomReport.vue'),
  },
  {
    path: 'self-compare',
    name: 'admin:reports:self-compare',
    component: () => import(/* webpackChunkName: "reports" */ '@/views/admin/management/reports/SelfCompare.vue'),
  },
]
